<template lang="pug">
.swap-battery-button-wrapper
  //- 主按钮
  .main-button(
    @click="handleClick"
    v-flash="{scale:0.9,boom:true}"
  )
    .button-content
      highlightText(
        v-if="buttonMainText"
        :text="buttonMainText"
        :normalStyle="buttonNormalStyle"
        :highlightStyle="buttonHighlightStyle"
      )
      .sub-text(v-if="buttonSubText") {{ buttonSubText }}
</template>

<script>
import highlightText from '@/components/highlight-text.vue';

export default {
  name: 'SwapBatteryButton',
  components: {
    highlightText,
  },
  props: {
    // 按钮主文案
    buttonMainText: {
      type: String,
      required: true,
    },
    // 按钮副文案
    buttonSubText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 按钮文案普通样式
      buttonNormalStyle: {
        fontSize: '0.16rem',
        fontWeight: 600,
        color: '#fff',
      },
      // 按钮文案高亮样式
      buttonHighlightStyle: {
        fontSize: '0.20rem',
        color: '#fff',
        fontWeight: 600,
      },
    };
  },
  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="less" scoped>
.swap-battery-button-wrapper {
  width: 100%;
  padding: 0 0.2rem;
  box-sizing: border-box;

  // 主按钮样式
  .main-button {
    position: relative;
    width: 3.35rem;
    height: 0.6rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.45rem;
    background: linear-gradient(to right, #f13e7b, #f4573d);
    box-sizing: border-box;

    .button-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      border-radius: 0.45rem;

      .bg-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .button-content {
      position: relative;
      z-index: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 0 0.3rem;
      box-sizing: border-box;

      .sub-text {
        font-size: 0.12rem;
        color: rgba(255, 255, 255, 0.9);
        text-align: center;
        margin-top: 0.04rem;
        line-height: 1.4;
      }
    }
  }
}
</style>
